<template>
    <nav class="navbar fixed-top shadow navbar-expand-lg navbar-light bg-light">
        <div class="container">        
            <a class="navbar-brand" href="/"> <img src="../assets/images/silvertrip-logo.png" alt=""> </a>
            <!-- <a class="navbar-brand" href="#">SilverTrip</a> -->
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <!-- col auto start -->
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <!-- <a class="nav-link" href="#">Accueil <span class="sr-only">(current)</span></a> -->
                        <router-link class="nav-link" to="/"> Accueil<span class="sr-only">(current)</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/offres">Offres</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/about">Contacts</router-link>
                    </li>
                </ul>
            </div>
            <!-- col auto end -->
        </div>
    </nav>
</template>

<style lang="scss">
    .bg-light {
        background-color: #ffffff !important;
    }
    .navbar-brand {
        font-weight: bold;
        font-size: 30px;
    }
    .navbar-light .navbar-nav .nav-link {
        font-weight: 700;
        font-size: 18px;
        text-transform: uppercase;
    }
    .navbar-light .navbar-nav .nav-item {
        margin: 0 15px;
    }
</style>

<script>
export default {
    
}
</script>